/**
 *                                          __  __
 *    ____  ______      ______ _      __   / /_/ /_  ___  ____ ___  ___
 *   / __ \/ ___/ | /| / / __ \ | /| / /  / __/ __ \/ _ \/ __ `__ \/ _ \
 *  / / / (__  )| |/ |/ / /_/ / |/ |/ /  / /_/ / / /  __/ / / / / /  __/
 * /_/ /_/____/ |__/|__/\____/|__/|__/   \__/_/ /_/\___/_/ /_/ /_/\___/
 *
 * ns.wow WordPress theme
 * by Neidhart + Schön Group
 */

// Bundle theme module (NSTheme)

import Helper from './Classes/Helper';
import FocusHandler from './Classes/FocusHandler';
import LazyLoad from 'vanilla-lazyload';
import ResponsiveTable from "./Classes/ResponsiveTable";

import XDownloader from "./Classes/XDownloader";
import CountUpNumbers from './Classes/CountUpNumbers';
import CardHeights from './Classes/CardHeights';
import Header from "./Classes/Header";
import Accordion from './Classes/Accordion';
import Video from './Classes/Video';
import HorizontalScroll from './Classes/HorizontalScroll';
import Breadcrumb from './Classes/Breadcrumb';
import Sidenav from './Classes/Sidenav';
import KeyfigureAnimation from './Classes/KeyfigureAnimation';
import Overlay from './Classes/Overlay';
import SidebarMobile from './Classes/SidebarMobile';
import ScrollToTop from './Classes/ScrollToTop';
import PrevNextTablet from './Classes/PrevNextTablet';
import InteractiveMap from './Classes/InteractiveMap';
import Downloadcenter from './Classes/Downloadcenter';
import Link from './Classes/Link';
import SliderHandler from "./Classes/SliderHandler";

import ProjectTeaser from './Classes/ProjectTeaser';
import Indikatoren from './Classes/Indikatoren';

import ReadingProgress from './Classes/ReadingProgress';
import Glossary from './Classes/Glossary';
import TableTitle from './Classes/TableTitle';
import FootnoteIndent from './Classes/FootnoteIndent';
import FieldsOfAction from './Classes/FieldsOfAction';
import Animation23 from './Classes/Animation23';


// import Jump from './Classes/Jump'
// import Sticky from '../../node_modules/sticky-js';
// import YoutubeLinks from './Classes/YoutubeLinks';

var focusHandlerInstance = null;
var lazyLoadInstance = null;
var responsiveTableInstance = null;
var downloaderInstance = null;
var tableTitleInstance = null;
var footnoteIndentationInstance = null;

var accordionInstance = null;
var jumpInstance = null;
var youtubeLinksInstance = null;

var countUpInstance = null;
var cardHeightsInstance = null;
var videoInstance = null;

var horizontalScrollInstance = null;
var keyfigureAnimationInstance = null;

var sidenavInstance = null;
var overlayInstance = null;
var sidebarMobileInstance = null;

var toTopInstance = null;
var prevNextTabletInstace = null;

var headerInstance = null;

var interactiveMapInstance = null;
var readingProgress = null;

var glossary = null;

var downloadcenter = null;
var linkInstance = null;

var breadcrumbInstance = null;
var sliderInstance = null;

var projectTeaserInstance = null;
var indikatoren = null;


export default {

  version: () => {
    return NSContext.theme.version;
  },

  lazyload: (givenNodeset) => {
    lazyLoadInstance.update(givenNodeset);
  }

  // addYoutubeLink: (videoContainer) => {
  //   youtubeLinksInstance.addLink(videoContainer);
  // }

};


// Initialize on document ready

document.addEventListener("DOMContentLoaded", function () {

  var lang = document.documentElement.lang;
  if ( lang == "en" || lang == "en-US" ) {
    Highcharts.setOptions({
      lang: {
        decimalPoint: '.', // default: '.'
        numericSymbols: null, // default: ["k", "M", "G", "T", "P", "E"], set to null to see full numbers
        thousandsSep: ',', // default: '\u0020'
        shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], // default: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      }
    });
  } else {
    Highcharts.setOptions({
      lang: {
        decimalPoint: ',', // default: '.'
        numericSymbols: null, // default: ["k", "M", "G", "T", "P", "E"], set to null to see full numbers
        thousandsSep: '.', // default: '\u0020'
        shortMonths: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"], // default: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
      }
    });
  }

  focusHandlerInstance = new FocusHandler();

  lazyLoadInstance = new LazyLoad();

  videoInstance = new Video();

  headerInstance = new Header({
    scrollDistanceClass: '.header__top',
    headerSelector: '.header',
    menuTogglerSelector: '.js-main-menu .menu__item--level-0.menu__item--has-children',
    menuLevelTogglerSelector: '.menu__item--has-children:not(.menu__item--level-0)',
    menuLevelNoTogglerSelector: '.menu__item--has-no-children:not(.menu__item--level-0)',
    menuContainerSelector: '.menu__wrap',
    mobileTogglerSelector: '.js-mobile-menu',
    mobileContainerSelector: '.js-main-menu',
    postContainerSelector: '.js-menu-post',
    languageTogglerSelector: '.js-language-switch',
    languageContainerSelector: '.js-language-dropdown',
    searchTogglerSelector: '.js-search-switch',
    searchContainerSelector: '.js-search-dropdown',
    reportTogglerSelector: '.js-report-switch',
    reportContainerSelector: '.js-report-dropdown'
  });

  // responsiveTableInstance = new ResponsiveTable({
  //   tableSelector: '.ns-table-wrap table',
  //   tableWrapperSelector: '.ns-table-wrap',
  //   breakPointLg: 1200,
  //   breakPointMd: 768,
  //   breakPointSm: 480,
  //   colCountNoSplit: 3,
  //   colCountEarlyBreak: 5,
  //   noSplitArray: []
  // });

  horizontalScrollInstance = new HorizontalScroll({
    containerSelector: '.ns-table-wrap > div, .ns-chart__chart, .interactive-map__wrapper'
  });

  sidenavInstance = new Sidenav({
    containerSelector: '.ns-anchor-container'
  });

  sidebarMobileInstance = new SidebarMobile({
    sidebarTriggerButtonSelector: '.sidebar__mobile-trigger-button',
    sidebarFurtherLinks: ".sidebar__button--related-links"
  })

  overlayInstance = new Overlay({
    overlayButtonSelector: '.sidebar__button[href]:not(.sidebar__button--last-year-comparison):not(.sidebar__button--chapter-download)',
    overlayTagmagButtonSelector: '.sidebar__button--tagfilter',
    openerSelector: ".js-tagmag-box",
    openerTagSelector: ".js-tagmag-box-name"
  });

  keyfigureAnimationInstance = new KeyfigureAnimation({
    keyfigureSelector: '.ns-keyfigure'
  });


  tableTitleInstance = new TableTitle({
    tableWrapper: '.ns-outer-table-wrapper',
    tableTitleClass: '.ns-tbl-head_top',
    tableTitlePosition: '.ns-table-title'
  });

  footnoteIndentationInstance = new FootnoteIndent({
    listSelector: '.ns-footnote__list',
    listStyleSelector: '.ns-footnote-star'
  });

  downloaderInstance = new XDownloader({
    downloadText: " ", //Can be empty if you want to use an icon instead
    backgroundColor: "ffffff", //Colored Cells Background
    backgroundClass2: 'ns-tbl-head_nb',
    backgroundClass2b: 'ns-tbl-head_nb_bold_petrol',
    backgroundClass3: 'ns-tbl-head_nb_2',
    backgroundClass3b: 'ns-tbl-head_nb_bold',
    borderColor: 'd8d8da', //Color of border
    borderColor2: '00607b',
    borderStyle: 'thin', // thin/dotted/medium/double/thick
    borderStyle2: 'medium', // thin/dotted/medium/double/thick
    headClass: 'ns-tbl-head', //Class you want your columns based on. Will be bold in Excel
    headClass2: 'ns-tbl-head_light', //Class you want your columns based on. Will be bold in Excel
    headClass3: 'ns-tbl-head_line', //Class you want your columns based on. Will be bold in Excel
    headColor: 'FFFFFF',
    boldClass: 'ns-tbl-noline_bold', //Class for Bold text in Excel
    boldClass2: 'ns-tbl-line_medium', //Class for Bold text in Excel
    boldClass3: 'ns-tbl-line_bold', //Class for Bold text in Excel
    boldClass4: 'ns-tbl-noline_medium', //Class for Bold text in Excel
    boldColor: '00607b',
    borderClass: 'ns-borderbottom-1-solid-black-20',
    borderClass2: 'ns-tbl-head',
    borderClass3: 'ns-tbl-head_light',
    borderClass4: 'ns-tbl-noline_first',
    borderClass5: 'ns-bordertop-1-solid-blueline-100',
    borderClass6: 'ns-tbl-bline_last',
    indClass: 'ns-tbl-line_ind',
    indClass2: 'ns-tbl-noline_ind',
    indClass3: 'ns-tbl-line_black_ind',
    highlightBorderTopClass: 'ns-bordertop-1-solid-frame-100',
    highlightBorderRightClass: 'ns-borderright-1-solid-frame-100',
    highlightBorderBottomClass: 'ns-borderbottom-1-solid-frame-100',
    highlightBorderLeftClass: 'ns-borderleft-1-solid-frame-100',
    highlightBorderColor: '009aa8', //Color of highlight border
    highlightBorderStyle: 'thick', // thin/dotted/medium/double/thick
    externalFootnotes: true,
    footnoteClass: 'ns-footnote__item',
    defaultTextColor: '555756'
  });

  accordionInstance = new Accordion( {
    accordions: '.ns-accordion__head',
    pxCorrection: 67
  });


  // jumpInstance = new Jump({
  //   graphicSelector: '.ns-graphic'
  // });

  // youtubeLinksInstance = new YoutubeLinks({
  // });

  countUpInstance = new CountUpNumbers({
    numbersSelector: '.ns-keyfigure__number',
    classIn: 'in-viewport',
    classOut: 'not-in-viewport',
    langArray: ['de-DE', 'en-US'],
    decimalArray: [',', '.'],
    thousandSepArray: ['.',','],
  });

  // cardHeightsInstance = new CardHeights({
  //   cardContainerSelector: '.ns-two-col-container',
  //   cardSelector: '.ns-card__content'
  // });

  toTopInstance = new ScrollToTop({
    buttonSelector: '.js-backtotop-toggle'
  });

  prevNextTabletInstace = new PrevNextTablet({
    buttonSelector: '.prev-next__link',
    childTextElementSelector: '.prev-next__text'
  });

  interactiveMapInstance = new InteractiveMap({
      urlPart: '/wp-json/public/posts/',
      urlPartCategories: '/wp-json/public/categories',
      categoriesName: 'map',
      mapClass: '.ns-table-wrap',
      filterContainer: '.ns-interactive-map__filter',
      svgElements: '.interactive-map__wrapper svg',
      filterTitelClass: 'filtertitle',
      mapTitle: '.ns-interactive-map__title',
      mapInfo: '.ns-interactive-map__infotext',
      tableHeadClass: '.ns-tbl-head',
      svgClass: '.interactive-map__svg-item',
      switchClass: '.switch input',
      mapContainer: '.interactive-map__wrapper',
      mapInnerContainer: '.ns-interactive-map__inner',
      hasFilterClass: '.with-filter-rest-api-call',
      popups: '.ns-map-popup',
      additionalFilter: '#js-filter-accordion-99'
  });

  sliderInstance = new SliderHandler({
    outerWrapperSelector: '.ns-magazine-slider__wrapper'
  });

  readingProgress = new ReadingProgress({
    readingProgress: '.js-reading-progress'
  });

  glossary = new Glossary({
    glossaryItemsSelector: ".ns-highlight"
  });

  downloadcenter = new Downloadcenter({
    downloadPage: ".page-template-page-downloadcenter",
    linkItems: ".exceldl-link"
  })

  linkInstance = new Link({
    linksSelector: '.js-target-blank'
  });

  breadcrumbInstance = new Breadcrumb({
    breadcrumb: '.breadcrumbs__container',
    breadcrumbs: '.breadcrumbs__item'
  });

  projectTeaserInstance = new ProjectTeaser();

  indikatoren = new Indikatoren({
    griIndiSelector: ".ns-indikator--gri",
    sasbIndiSelector: ".ns-indikator--sasb",
    ungcIndiSelector: ".ns-indikator--ungc"
  });

  new FieldsOfAction();
  new Animation23();
});
